import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, BookOpen } from "lucide-react";
import PageMeta from "@/components/PageMeta";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen pt-32 pb-20 flex items-center justify-center px-4" data-testid="not-found-page">
      <PageMeta title="Page Not Found | Digital Media Ninja" robots="noindex, nofollow" />
      <div className="text-center max-w-md">
        <p className="text-[#00E676] font-bold text-6xl mb-4">404</p>
        <h1 className="text-2xl font-bold mb-3">Page Not Found</h1>
        <p className="text-gray-400 text-sm mb-8">
          The page you're looking for doesn't exist or has moved.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/" data-testid="not-found-home-link">
            <Button className="btn-ninja px-6"><Home className="w-4 h-4 mr-2" /> Back Home</Button>
          </Link>
          <Link to="/blog" className="text-gray-400 hover:text-[#00E676] text-sm inline-flex items-center gap-1" data-testid="not-found-blog-link">
            <BookOpen className="w-4 h-4" /> Browse the blog
          </Link>
        </div>
      </div>
    </div>
  );
}
